import React from 'react';
import moment from 'moment';
import ResourceStartTimeList from './ResourceStartTimeList';
import { toasty } from '../common/forms/FormElements';

export default class DayResourcesPanel extends React.Component {
    onChangeLongTermResourceDay = (weekResource, e) => {
        const { disabled } = this.props;
        if (disabled) {
            return;
        }

        const { job, onJobUpdated } = this.props;

        const {
            flaggerResource,
            weekOfDate,
            dayName,
            equipmentResource,
            isCheckbox,
        } = weekResource;

        let val = 0;

        if (isCheckbox) {
            val = e.target.checked ? 1 : 0;
        } else {
            val = parseInt(e.target.value);

            if (isNaN(val)) {
                val = 0;
            }

            if (val >= 100) {
                toasty.error('Resource assignment cannot exceed 100.');
                return;
            }
        }

        job.weekJobResources.forEach((wjr) => {
            if (wjr.weekOfDate != weekOfDate) {
                return;
            }

            const jobResource = wjr.jobResources.find(
                (jr) =>
                    (flaggerResource &&
                        jr.applicationGroupId ===
                            flaggerResource.applicationGroupId) ||
                    (equipmentResource &&
                        jr.equipmentGroupId ==
                            equipmentResource.equipmentGroupId)
            );

            if (!jobResource) {
                return;
            }

            jobResource[dayName] = val;
        });

        onJobUpdated(job);
    };

    onJobResourceStartTimesChanged = (jobResource, times) => {
        const { dayOfDate, onJobUpdated, job } = this.props;

        const workDate = dayOfDate ? moment(dayOfDate) : moment();
        const normalizedOverrides = (times || [])
            .filter((timeEntry) => moment(timeEntry.value, 'HH:mm', true).isValid())
            .map((timeEntry) => {
                const parsedTime = moment(timeEntry.value, 'HH:mm', true);

                return {
                    id:
                        !timeEntry.id ||
                        timeEntry.id.constructor === String
                            ? null
                            : timeEntry.id,
                    date: workDate.clone().startOf('day').toDate(),
                    startTime: workDate
                        .clone()
                        .hour(parsedTime.hour())
                        .minute(parsedTime.minute())
                        .second(0)
                        .millisecond(0)
                        .toDate(),
                    arcGisOriginId: timeEntry.startLocationId ?? null,
                    arcGisDestinationId: timeEntry.endLocationId ?? null,
                    roadName:
                        timeEntry.startLocationId || timeEntry.endLocationId
                            ? ''
                            : timeEntry.startLocationText ?? '',
                };
            });

        jobResource.jobResourceOverrides = normalizedOverrides;

        onJobUpdated(job);
    };

    render() {
        const {
            wjrKey,
            weekOfDate,
            dayName,
            jobResources,
            flaggerResource,
            flaggerGroup,
            equipmentGroups,
            arcGisLocations,
            edit,
            disabled,
        } = this.props;
        const propsJob = this.props.job;
        const jobStartTime = propsJob?.startTime;
        const workDate = moment(weekOfDate);
        if (dayName) {
            workDate.day(dayName);
        }
        const workDateLabel = workDate.isValid()
            ? workDate.format('MM/DD/YYYY')
            : '';

        return (
            <div className="border rounded p-2 h-100 day-resources-panel">
                <div className="small text-uppercase text-muted mb-2">
                    Resources
                </div>
                <div className="d-flex flex-column flex-md-row align-items-md-center mb-2">
                    <div className="font-weight-bold mr-md-2 mb-1 mb-md-0">
                        Flaggers
                    </div>
                    <div className="flex-grow-1">
                        {edit.allowResources ? (
                            <ResourceStartTimeList
                                max={flaggerResource[dayName]}
                                arcGisLocations={arcGisLocations}
                                jobStartTime={jobStartTime}
                                jobResourceOverrides={flaggerResource.jobResourceOverrides}
                                onOverridesChange={this.onJobResourceStartTimesChanged.bind(
                                    this,
                                    flaggerResource
                                )}
                                disabled={disabled}
                                resourceLabel="Flaggers"
                                workDateLabel={workDateLabel}
                                renderCountInput={() => (
                                    <input
                                        id={`${wjrKey}-fr-${dayName}`}
                                        name={`${wjrKey}-fr-${dayName}`}
                                        className="flex-grow-1 w-auto"
                                        required
                                        value={flaggerResource[dayName]}
                                        onChange={this.onChangeLongTermResourceDay.bind(
                                            this,
                                            {
                                                flaggerResource,
                                                flaggerGroup,
                                                weekOfDate,
                                                dayName,
                                            }
                                        )}
                                        disabled={disabled}
                                        inputMode="numeric"
                                    />
                                )}
                            />
                        ) : (
                            <input
                                id={`${wjrKey}-fr-${dayName}`}
                                name={`${wjrKey}-fr-${dayName}`}
                                className="w-100"
                                required
                                value={flaggerResource[dayName]}
                                onChange={this.onChangeLongTermResourceDay.bind(
                                    this,
                                    {
                                        flaggerResource,
                                        flaggerGroup,
                                        weekOfDate,
                                        dayName,
                                    }
                                )}
                                readOnly
                            />
                        )}
                    </div>
                </div>

                {equipmentGroups.map((equipmentGroup) => {
                    const equipmentResource = jobResources.find(
                        (jr) => jr.equipmentGroupId == equipmentGroup.id
                    );

                    return (
                        <div
                            key={`${wjrKey}-eg-${equipmentGroup.id}-${dayName}`}
                            className="d-flex flex-column flex-md-row align-items-md-center mb-2"
                        >
                            <div className="font-weight-bold mr-md-2 mb-1 mb-md-0">
                                {equipmentGroup.isTruck && 'Brokered '}
                                {equipmentGroup.name}
                            </div>
                            <div className="flex-grow-1">
                                {!equipmentGroup.isSpecialty &&
                                    (edit.allowResources ? (
                                        <ResourceStartTimeList
                                            max={equipmentResource[dayName]}
                                            arcGisLocations={arcGisLocations}
                                            jobStartTime={jobStartTime}
                                            jobResourceOverrides={equipmentResource.jobResourceOverrides}
                                            onOverridesChange={this.onJobResourceStartTimesChanged.bind(
                                                this,
                                                equipmentResource
                                            )}
                                            disabled={disabled}
                                            resourceLabel={equipmentGroup.name}
                                            workDateLabel={workDateLabel}
                                            renderCountInput={() => (
                                                <input
                                                    id={`${wjrKey}-eg${equipmentGroup.id}-${dayName}`}
                                                    name={`${wjrKey}-eg${equipmentGroup.id}-${dayName}`}
                                                    className="flex-grow-1 w-auto"
                                                    required
                                                    value={
                                                        equipmentResource[
                                                            dayName
                                                        ]
                                                    }
                                                    onChange={this.onChangeLongTermResourceDay.bind(
                                                        this,
                                                        {
                                                            equipmentResource,
                                                            equipmentGroup,
                                                            weekOfDate,
                                                            dayName,
                                                        }
                                                    )}
                                                    disabled={disabled}
                                                />
                                            )}
                                        />
                                    ) : (
                                        <input
                                            id={`${wjrKey}-eg${equipmentGroup.id}-${dayName}`}
                                            name={`${wjrKey}-eg${equipmentGroup.id}-${dayName}`}
                                            className="w-100"
                                            required
                                            value={equipmentResource[dayName]}
                                            onChange={this.onChangeLongTermResourceDay.bind(
                                                this,
                                                {
                                                    equipmentResource,
                                                    equipmentGroup,
                                                    weekOfDate,
                                                    dayName,
                                                }
                                            )}
                                            readOnly
                                        />
                                    ))}

                                {equipmentGroup.isSpecialty && (
                                    <input
                                        id={`${wjrKey}-eg${equipmentGroup.id}-${dayName}`}
                                        name={`${wjrKey}-eg${equipmentGroup.id}-${dayName}`}
                                        className="w-auto"
                                        type="checkbox"
                                        checked={equipmentResource[dayName]}
                                        onChange={this.onChangeLongTermResourceDay.bind(
                                            this,
                                            {
                                                equipmentResource,
                                                equipmentGroup,
                                                weekOfDate,
                                                dayName,
                                                isCheckbox: true,
                                            }
                                        )}
                                        readOnly={!edit.allowResources}
                                        disabled={disabled}
                                    />
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

